import React from 'react';
import PropTypes from 'prop-types';

export default function BaseDialogLayoutHeader({ footer, footerClassName }) {
  if (!footer) {
    return null;
  }

  return <footer className={`base-dialog-layout-footer-wrapper ${footerClassName}`}>{footer}</footer>;
}

BaseDialogLayoutHeader.propTypes = {
  footer: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  footerClassName: PropTypes.string,
};
